import template from './onboardingAsic.html';
import controller from './onboardingAsicCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {},
};
